export { default as securedReducers } from 'secured/reducers/secured_reducers';



// WEBPACK FOOTER //
// src/modules/secured/reducers/index.js